import {Tooltip} from "@mui/material";
import {Box, Chip, CloseDialogButton, Colors, Divider, Drawer, IconInfo, Text} from "@bounce/shared/ui";
import {NumPerChannel} from "../../apis/requests/audiences/types";
import {CHANNEL_DISPLAY} from "../templates/templateDisplay";
import {TEMPLATE_CHANNEL_ORDER} from "./templatesPerChannel";

export type ChannelBreakdownRow = {
  campaign_segment_names: string[];
  num_of_templates_per_channel: NumPerChannel;
  audience_per_channel: NumPerChannel;
};

type Props = {
  audience: ChannelBreakdownRow | null;
  scope?: "audience" | "campaign";
  onClose: () => void;
};

export const TemplatesPerChannelDrawer = ({audience, scope = "audience", onClose}: Props) => (
  <Drawer anchor="right" open={!!audience} onClose={onClose}>
    <Box sx={{width: 360, p: 3, position: "relative"}}>
      <CloseDialogButton onClose={onClose} />
      <Text size={16} variant="interDisplay600" sx={{color: Colors.grey._900, mb: 0.5}}>
        Templates per channel
      </Text>
      <Box sx={{display: "flex", flexWrap: "wrap", gap: 0.5, mb: 3}}>
        {audience?.campaign_segment_names.length ? (
          audience.campaign_segment_names.map((name, i) => (
            <Chip key={i} size_="small" variant_="inherit" label={name} />
          ))
        ) : (
          <Chip size_="small" variant_="inherit" label="Default" />
        )}
      </Box>
      <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
        {audience &&
          TEMPLATE_CHANNEL_ORDER.map((channel) => (
            <Box key={channel} sx={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
              <Chip size_="small" variant_={CHANNEL_DISPLAY[channel].variant} label={CHANNEL_DISPLAY[channel].label} />
              <Text size={14} variant="inter600" sx={{color: Colors.grey._900}}>
                {audience.num_of_templates_per_channel[channel].toLocaleString()}
              </Text>
            </Box>
          ))}
      </Box>
      <Divider sx={{my: 3}} />
      <Box sx={{display: "flex", alignItems: "center", gap: 0.5, mb: 2}}>
        <Text size={16} variant="interDisplay600" sx={{color: Colors.grey._900}}>
          Accounts reachable per channel
        </Text>
        <Tooltip
          title={`Number of accounts in this ${scope} that have each channel available to communicate with.`}
        >
          <Box component="span" sx={{display: "inline-flex", cursor: "help"}}>
            <IconInfo color={Colors.grey._600} width={13} />
          </Box>
        </Tooltip>
      </Box>
      <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
        {audience &&
          TEMPLATE_CHANNEL_ORDER.map((channel) => (
            <Box key={channel} sx={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
              <Chip size_="small" variant_={CHANNEL_DISPLAY[channel].variant} label={CHANNEL_DISPLAY[channel].label} />
              <Text size={14} variant="inter600" sx={{color: Colors.grey._900}}>
                {audience.audience_per_channel[channel].toLocaleString()}
              </Text>
            </Box>
          ))}
      </Box>
    </Box>
  </Drawer>
);
